<div class="container h-100 d-flex align-items-center p-5" *ngIf="isLoading">
    <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
</div>

<div *ngIf="!isLoading">
    <div class="container mt-5 mb-5 w-50 mx-auto" *ngIf="!isRebillingSetup">
        <div class="row">
            <p>To create payment plans, please complete the stripe account creation to be able to receive payments</p>
        </div>
        <div class="row ">
            <button mat-raised-button (click)="onStripeConnectRequest()" class="mx-auto d-block mt-4">Configure
                Stripe</button>
        </div>
    </div>
    <div class="container mt-5 mb-5 " *ngIf="isRebillingSetup">
        <div class="row">
            <div class="col-12 d-flex justify-content-end">
                <button mat-raised-button class="d-block mt-4" (click)="onCreatePlan()">Add Plan</button>
            </div>
        </div>

        <h1 class="mb-0">View add and edit your current payment plans</h1>
        <h4 class="fw-light mb-0">Decide what you would charge your customers</h4>

        <mat-divider class="mt-4 mb-4"></mat-divider>
        <div class="row">
            <app-custom-payment-plan [plans]="plans" [isPurchaseMode]="false"></app-custom-payment-plan>
        </div>
    </div>
</div>